exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".break-selection-form .break-options,.break-selection-form .break-text{padding-bottom:20px}.break-selection-form .break-ok-button{width:100%;text-align:right}", "", {"version":3,"sources":["/./ba/work/f461d656cf32a8e2/src/components/Employee/D:/ba/work/f461d656cf32a8e2/src/components/Employee/CalendarBreakSelectionForm.scss"],"names":[],"mappings":"AACE,uEACE,mBAAA,CAGF,uCACE,WACA,gBAAA,CAAA","file":"CalendarBreakSelectionForm.scss","sourcesContent":[".break-selection-form .break-text,.break-selection-form .break-options{padding-bottom:20px}.break-selection-form .break-ok-button{width:100%;text-align:right}"],"sourceRoot":"webpack://"}]);

// exports
